import { LifecycleHook } from '@passkeys/application';
const LIFECYCLE_METHOD_TO_HOOK_NAME = Object.fromEntries(Object.entries(LifecycleHook).map(([pascalCaseName, hookName]) => [
    `on${pascalCaseName}`,
    hookName,
]));
const attachPlugins = ({ plugins, application, logger }) => {
    const timeFn = (fn, name) => {
        const pluginWrapper = async (...args) => {
            const start = Date.now();
            try {
                return await fn(...args);
            }
            finally {
                logger.debug(name, `${Date.now() - start}ms`);
            }
        };
        Object.defineProperty(pluginWrapper, 'name', {
            value: name,
            writable: false,
        });
        return pluginWrapper;
    };
    Object.entries(plugins).forEach(([name, lifecycleMethods]) => {
        const entries = Object.entries(lifecycleMethods || {});
        for (const [lifecycleMethod, fn] of entries) {
            const hookName = LIFECYCLE_METHOD_TO_HOOK_NAME[lifecycleMethod];
            if (hookName) {
                application.hook(hookName, timeFn(fn, `plugin ${name}.${lifecycleMethod}`));
            }
            else {
                logger.error(`plugin "${name}" declares unsupported lifecycle method "${lifecycleMethod}"`);
            }
        }
    });
};
export default attachPlugins;
